import { X } from 'lucide-react';
import type { GrandSlamResource } from '../../constants/prestart.constants';
import { GrandSlamResourceLinkCard } from '../grand-slam-resource-link-card';
import { ProbabilityResponsiveModal } from '../modals/probability-responsive-modal';

interface ResourcesGuideModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	title: string;
	intro: string;
	items: GrandSlamResource[];
}

function ResourcesGuideContent({
	title,
	intro,
	items,
	onClose,
}: {
	title: string;
	intro: string;
	items: GrandSlamResource[];
	onClose: () => void;
}) {
	return (
		<div className="flex flex-col font-['DM_Sans']">
			<div className="flex items-center gap-4 px-4 pb-3 pt-3.5">
				<div className="h-6 w-6 shrink-0" aria-hidden="true" />
				<p className="flex-1 text-center text-base font-bold leading-[22px] tracking-[-0.6px] text-[#0A0A0A]">
					{title}
				</p>
				<button
					type="button"
					onClick={onClose}
					className="flex h-6 w-6 shrink-0 items-center justify-center rounded-[4px] text-[#474747]"
					aria-label="Close"
				>
					<X className="h-5 w-5" strokeWidth={2} />
				</button>
			</div>

			<div className="max-h-[min(70vh,520px)] overflow-y-auto px-4 pb-6">
				<p className="pb-5 text-sm leading-5 tracking-[-0.392px] text-[#474747]">{intro}</p>

				<div className="flex flex-col gap-3">
					{items.map((resource, index) => (
						<GrandSlamResourceLinkCard
							key={`${resource.title}-${resource.href}-${index}`}
							{...resource}
							variant="guide"
						/>
					))}
				</div>
			</div>
		</div>
	);
}

export function ResourcesGuideModal({
	open,
	onOpenChange,
	title,
	intro,
	items,
}: ResourcesGuideModalProps) {
	return (
		<ProbabilityResponsiveModal
			open={open}
			onOpenChange={onOpenChange}
			title={title}
			description={intro}
			drawerClassName="z-100"
			dialogPlacement="top-right"
			dialogClassName="w-[393px] max-w-[calc(100%-32px)] rounded-2xl"
		>
			<ResourcesGuideContent
				title={title}
				intro={intro}
				items={items}
				onClose={() => onOpenChange(false)}
			/>
		</ProbabilityResponsiveModal>
	);
}
